import {inject, injectable} from "inversify";
import {InternalChatRepository} from "@dropDesk/domain/repositories/internal_chat/internal_chat.repository";
import {InternalChatEntity} from "@dropDesk/domain/entities/internal_chat/internal_chat_entity";
import {InternalChatUserEntity} from "@dropDesk/domain/entities/internal_chat/users/internal_chat_user_entity";

@injectable()
export class ChangeUsersInternalChatUseCase {
  private _repository: InternalChatRepository;

  constructor(@inject(InternalChatRepository) repository: InternalChatRepository) {
    this._repository = repository;
  }

  public call(id: string, users: InternalChatUserEntity[]): Promise<InternalChatEntity> {
    return this._repository.changeUsers(id, users);
  }
}
